export const onColorPredictionSelect = (payload) => ({
  type: "COLOR_PREDICTION_SELECT_COLOR",
  payload,
});

export const onColorPredictionReset = (payload) => ({
  type: "COLOR_PREDICTION_RESET",
  payload: payload,
});

export const onColorPredictionSubmit = (payload) => ({
  type: "COLOR_PREDICTION_SUBMIT",
  payload: payload,
});
